import React from "react";
import { Link } from "react-router";
import Nav from '../components/Nav';
import { database, auth } from '../firebase';
import ms from '../ms';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';
import Skeleton from "react-loading-skeleton";

class UserId extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: [],
      posts: [],
      bio: "",
      bannerUrl: "",
      userName: "",
      userImage: "/default.jpg"
    };
  }

  componentDidMount() {
    const userId = window.location.pathname.slice(8);

    // Fetch user data
    database.ref("users/" + userId).get().then(snap => {
      if (snap.exists()) {
        const userData = snap.val();
        this.setState({
          user: userData,
          userName: userData.userName,
          bio: userData.bio || "",
          joined: userData.joined,
          userImage: userData.userImage || "/default.jpg"
        });

        // Set banner based on the user's banner selection
        const bannerUrls = {
          1: "https://png.pngtree.com/thumb_back/fh260/background/20190223/ourmid/pngtree-pure-color-watercolor-graffiti-gradient-background-board-design-board-design-image_66713.jpg",
          2: "http://www.pngmagic.com/product_images/rain-background-banner-min.jpg",
          3: "https://img.wallpapersafari.com/desktop/1024/576/16/8/6oStix.png",
          4: "https://validatedlearning.co/wp-content/uploads/2017/08/green-geo-background-banner.jpeg"
        };
        const bannerUrl = userData.banner ? bannerUrls[userData.banner] || userData.banner : "/sss-banner.jpg";
        this.setState({ bannerUrl });
      } else {
        window.location.pathname = "/404";
      }
    });

    // Fetch user's posts
    const posts = [];
    database.ref("posts").on('child_added', snap => {
      if (snap.val().postAuthor === userId) {
        posts.push({
          id: snap.key,
          postTitle: snap.val().postTitle,
          postContent: snap.val().postContent,
          postDate: snap.val().postDate,
          postImage: snap.val().postImage,
          postAuthor: snap.val().postAuthor,
        });
      }

      this.setState({ posts });
    });
  }

  renderUrls = (text) =>
    text.split(/(https?:\/\/[^\s]+)/g).map((part, index) =>
      part.match(/https?:\/\/[^\s]+/) ? (
        <a key={index} href={part} target="_blank" rel="noopener noreferrer">
          {part}
        </a>
      ) : (
        part
      )
    );

  render() {
    const { userName, bio, joined, userImage, bannerUrl, posts } = this.state;

    console.log(joined);

    return (
      <div className="container">
        <Nav />
        <div className='main'>
          <div className="banner" style={{ background: `url(${bannerUrl}) center center / cover`, height: "200px" }}></div>
          <div className="card">
            <div className='card-image-c'>
              <img src={userImage} alt="Profil Görseli" className='card-image' />
            </div>

            <div style={{ maxWidth: "500px", margin: "auto" }}>
              <h1 className="card-title">{userName || <Skeleton width={200} height={30} style={{ borderRadius: "50px", opacity: ".8" }} />}</h1>
              <div className="card-text">
                {joined ? <div className="card-date">Katılma Tarihi: {ms(Date.now() - (joined), {long: true})} önce</div> : ""}

                <div className="skeleton-div">
                  {bio ? (
                    <ReactMarkdown rehypePlugins={[rehypeRaw]} remarkPlugins={[remarkGfm]}>
                      {bio}
                    </ReactMarkdown>
                  ) : (
                    <>
                      <Skeleton width={250} style={{ borderRadius: "20px", marginBottom: "5px", opacity: ".6" }} />
                      <Skeleton width={230} style={{ borderRadius: "20px", opacity: ".6" }} />
                    </>
                  )}
                </div>
              </div>

              {this.state.user.verified === true && (
                <>
                  <h1 className="h1" style={{ fontSize: "20px" }}>Bu Yazara Ait Yazılar</h1>
                  {posts.length > 0 ? posts.map(post => (
                    <Link to={`/p/${post.id}`} key={post.id}>
                      <div className="post">
                        <div className='post-image-c'>
                          <img src={post.postImage || "/default.jpg"} alt="Yazı Görseli" className='post-image' />
                        </div>
                        <h1 className="post-title">{post.postTitle}</h1>
                        <div style={{ textAlign: "left", height: "112px", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                          {post.postContent}
                        </div>
                        <div className="post-date">{ms(Date.now() - post.postDate, { long: true }) + " önce"}</div>
                      </div>
                    </Link>
                  )) : (
                    <a>Bu yazar henüz bir yazı yayınlamamış.</a>
                  )}
                </>
              )}
            </div>
          </div>
        </div>

        <style>{`
          html {
            background: #F57029;
          }

          .main {
            width: 100%;
            margin: 0 auto;
            margin-top: 48px;
            padding: 0;
          }

          .banner {
            width: 100%;
            height: 200px;
            margin-bottom: -5px;
            object-fit: cover;
            background: #f0651a;
          }

          .card {
            color: #fff;
            border-radius: 3px;
            padding: 25px 0;
            background: #F57029;
            width: max-content;
            margin: 0 auto;
            margin-top: 20px;
            display: flex;
          }

          .post {
            border-radius: 10px;
            margin: 10px 10px;
            padding: 15px;
            background: #2f2d33;
            width: 200px;
            max-width: 200px;
            height: 300px;
            display: inline-block;
            transition: .2s;
          }

          .post:hover {
            background: #5b5b5c;
          }

          .card-image {
            position: relative;
            margin: auto;
            border-radius: 500px;
            width: 150px;
            max-width: 200px;
            height: 150px;
            object-fit: cover;
            background-color: #fff;
          }

          .post-image {
            position: relative;
            margin: auto;
            border-radius: 5px;
            width: 100%;
            height: 140px;
            object-fit: cover;
          }

          .card-title {
            margin: 10px 0;
            padding-left: 15px;
            font-size: 36px;
          }

          .post-title {
            font-size: 16px;
            margin: 0;
            margin-top: 10px;
            color: #fff;
            text-align: left;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          .card-text {
            max-width: 500px;
            min-height: 40px;
            margin: 0 auto;
            margin-bottom: 30px;
            padding-left: 15px;
          }

          .card-text a:link, .card-text a:visited {
            font-weight: 700;
            color: #FFD700;
          }
          
          .card-text a:hover {
            color:rgb(253, 233, 119);
          }

          .card-date {
            margin-top: -5px;
            padding-bottom: 12px;
            border-bottom: 2px solid #fff;
          }

          .post-date {
            float: right;
            text-align: right;
            font-weight: bold;
            color: #fff;
            display: flex;
          }

          .h1 {
            text-align: center;
          }

          footer {
            margin: 0;
          }

          .skeleton-div {
            display: grid;
          }

          @media (max-width: 900px) and (min-width: 623px) {
            .main {
              margin-top: 0px;
            }
          }

          @media (max-width: 623px) {
            .main {
              width: 100%;
              margin-top: 0px;
              text-align: center;
            }

            .banner {
              height: 150px;
            }

            .card {
              margin: 0 auto;
              padding: 25px 0;
              padding-bottom: 62px;
              width: 100%;
              display: block;
            }

            .card-image {
              margin-top: -100px;
              border: 8px solid #f57029;
            }

            .card-title {
              padding: 0;
            }

            .card-text {
              max-width: 85%;
              text-align: left;
              padding: 0;
            }

            .card-date {
              margin-top: 10px;
              margin-right: 10px;
            }

            .post {
              width: 100%;
              max-width: 70%;
              height: auto;
              margin: 10px auto;
            }

            .skeleton-div {
              text-align: center;
            }
          }
        `}</style>
      </div>
    );
  }
}

export default UserId;